import { type ReactElement } from 'react';
import Input from '@creditflowresearch/uilib/Input';
import Flex from '@creditflowresearch/uilib/Flex';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';
import { FilterSectionIds } from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';
import usePrice from './usePrice';

import rangeStyles from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/styles/rangeFilter.module.scss';
import styles from '@/creditflowresearch/ui/common/components/DatePicker/styles/dateRangeFilter.module.scss';

const Price = (): ReactElement => {
  const { minValue, maxValue, minMeta, maxMeta, handleMinChange, handleMaxChange } = usePrice();

  return (
    <FilterSection
      sectionId={ FilterSectionIds.Price }
      header={ <FilterSectionHeader title="PRICE" /> }
      dataTest="priceSection"
    >
      <Flex gap={ 8 }>
        { /* @ts-ignore */ }
        <Input
          name="priceMin"
          type="text"
          placeholder="Min"
          value={ minValue }
          onChange={ handleMinChange }
          meta={ minMeta }
          formFieldClassName={ rangeStyles.field }
          inputClassName={ rangeStyles.input }
          dataTest="filterMinInput"
          isClearable={ false }
          isNarrow
        />
        <Flex direction="column" shrink="0">
          <span className={ styles.separator }>-</span>
        </Flex>
        { /* @ts-ignore */ }
        <Input
          name="priceMax"
          type="text"
          placeholder="Max"
          value={ maxValue }
          onChange={ handleMaxChange }
          meta={ maxMeta }
          formFieldClassName={ rangeStyles.field }
          inputClassName={ rangeStyles.input }
          dataTest="filterMaxInput"
          isClearable={ false }
          isNarrow
        />
      </Flex>
    </FilterSection>
  );
};

export default Price;
